import { Link } from "react-router-dom";
import { useLocale } from "@/i18n/useLocale";
import "./SectionCta.css";

interface SectionCtaProps {
  /** Texto del boton principal. Nombra la accion del visitante, no la nuestra. */
  label: string;
  /** Modificador de color, para que el boton use el acento de su seccion. */
  variant: "ecommerce" | "ai" | "software";
}

/**
 * Cierre de una seccion de servicio: un unico boton primario para contactar. La
 * accion secundaria es la tarjeta "Solucion" que ya vive en la propia seccion
 * (SolutionLink), y los casos tienen su seccion arriba: antes habia un tercer
 * llamado ("Ver casos") y cada bloque cerraba con tres decisiones.
 *
 * Existe porque las tres secciones de servicio tenian CERO puntos de conversion:
 * solo linkeaban a su pagina de casos. Quien se convencia leyendo la seccion
 * tenia que scrollear hasta el final de la home o buscar el boton flotante, es
 * decir justo en el momento de mayor intencion no habia donde hacer clic.
 *
 * Un solo CTA primario por seccion, con el secundario visiblemente subordinado:
 * dos botones del mismo peso no eligen por el usuario, lo hacen dudar.
 */
function SectionCta({ label, variant }: SectionCtaProps) {
  const { path } = useLocale();

  return (
    <div className={`section-cta section-cta--${variant}`}>
      <Link
        to={`${path("home")}#contacto`}
        className="section-cta__primary"
        title={label}
      >
        {label}
      </Link>
    </div>
  );
}

export default SectionCta;
